import { categoryLabel } from './assetCategories';
import { isAssetCategory } from './assetRegistryNormalize';

/** Stable color per allocation bucket so the pie and trend lines stay in sync. */
export const ALLOCATION_SEGMENT_COLORS: Record<string, string> = {
  portfolio: 'var(--accent)',
  bank_cash: 'var(--status-positive)',
  real_estate: '#5b56e3',
  cash: '#38bdf8',
  securities: '#a78bfa',
  private_equity: '#f59e0b',
  collectibles: '#fb7185',
  vehicle: '#94a3b8',
  business_equity: '#34d399',
  other_asset: '#cbd5e1',
};

export const ALLOCATION_FALLBACK_COLORS = [
  'var(--accent)',
  '#5b56e3',
  'var(--status-positive)',
  '#f59e0b',
  '#38bdf8',
  '#a78bfa',
  '#fb7185',
  '#94a3b8',
];

export function colorForAllocationRow(id: string, index: number): string {
  return (
    ALLOCATION_SEGMENT_COLORS[id] ??
    ALLOCATION_FALLBACK_COLORS[index % ALLOCATION_FALLBACK_COLORS.length]
  );
}

/** Human label for an allocation bucket id (registry category, portfolio, or bank cash). */
export function allocationLabel(id: string): string {
  if (id === 'portfolio') return 'Portfolio';
  if (id === 'bank_cash') return 'Bank cash';
  if (isAssetCategory(id)) return categoryLabel(id);
  return id;
}
